import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import { a as EGDSButton } from '../paging-button/index-chunk.esm.js';

class EGDSOverlayButton extends React.Component {
    static displayName = 'EGDSOverlayButton';
    render() {
        const { className, ...props } = this.props;
        const classNameOverlayButton = classNames(`${EGDSButton.baseClassName}-overlay`, className);
        return jsx(EGDSButton, { ...props, className: classNameOverlayButton });
    }
}

export { EGDSOverlayButton as E };
//# sourceMappingURL=index-chunk.esm.js.map
